<template>
  <div class="add-group-holder">
    <div v-if="showAddGroup" class="add-group add-group-padding">
      <div class=" add-group-padding">
        <div class="add-title">
          {{ groupEditTitle }}
        </div>
        <div class="add-line">
          <div class="line-title">
            group name
          </div>
          <input
              ref="groupName"
              type="text"
              class="add-tag-input"
              :value="getValue"
              @focus="handleNameFocus"
          >
        </div>
        <div class="add-line">
          <div class="line-title">
            group color
          </div>
          <ColorSelector />
        </div>
        <div class="feedback" v-if="message.length > 0">{{ message }}</div>
      </div>
    </div>
    <RightPanelButtons :save="handleGroupSave" :cancel="handleGroupCancel"/>

  </div>
</template>

<script>
import {mapStores, storeToRefs} from 'pinia/dist/pinia';
import {useRMTStore} from '@/store/RMTStore';
import ColorSelector from '@/components/rmt/ColorSelector';
import RightPanelButtons from '@/components/rmt/RightPanelButtons';
import {useTagStore} from '@/store/TagStore';

export default {
  name: 'AddGroup',
  components: {
    RightPanelButtons,
    ColorSelector
  },
  setup () {
    const RMTStore = useRMTStore(); 
    const { editGroup, groupData } = storeToRefs(RMTStore);
    const TagStore = useTagStore();
    return {
      RMTStore, editGroup, TagStore, groupData
    };
  },

  watch: {

    groupData () {
     this.RMTStore.selectedTagAddGroup = this.TagStore.groupData[this.TagStore.groupData.length-1];
    }
  },

  data () {
    return {
      message: ''
    };
  },
  computed: {
    ...mapStores(useRMTStore, useTagStore),
    showManageText () {
      return ''; // (!this.RMTStore.manageGroupMode) ? 'Manage Groups' : 'Done Managing Groups';
    },
    groupEditTitle () {
      return (this.RMTStore.showAddGroup && this.RMTStore.editGroup === null) ? 'ADD GROUP' : 'EDIT GROUP';
    },
    editTag () {
      const RMTStore = useRMTStore();
      return RMTStore.editTag;
    },
    showAddGroup () {
      const RMTStore = useRMTStore();
      return RMTStore.showAddGroup;
    },
    getValue () {
     return (this.editGroup === null) ? '' : this.editGroup.groupName;
    }
  },
  methods: {
    updateGroup (group) {
      this.RMTStore.updateGroup(group);
    },
    handleNameFocus () {
      this.message = '';
    },
    handleGroupCancel () {
      this.RMTStore.showAddGroup = false;
    },
    handleGroupSave () {
      if (this.$refs.groupName.value === '') {
        this.message = 'Enter a group name.';
        return;
      }
      const g = this.$refs.groupName.value;
      // edit
      if (this.RMTStore.manageGroupMode) {
        this.RMTStore.editGroup.groupName = this.$refs.groupName.value;
        this.updateGroup(this.RMTStore.editGroup);
        // create
      } else {
        this.updateGroup({
          groupId: 0,
          groupName: g,
          subscription: null,
          tagIds: []
        });
      }
      this.RMTStore.showAddGroup = false;
    },
  }
};
</script>

<style scoped>

.add-line {
  display: flex;
  align-items: center;
  justify-content: stretch;
  margin: 3px;
}

.add-group {
  position: relative;
  display: flex;
  align-items: flex-start;
/*  height: 100%;*/
/*  border: 1px solid black;*/
  background-color: white;
/*  padding: 20px;*/
}


.add-group-holder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.add-title {
  font-size: .8em;
  font-weight: 700;
}

.line-title {
  width: 25%;
  font-weight: 700;
  font-size: .9em;
}

.add-tag-input {
  width: 75%;
  height: 30px;
  background-color: #eeeeee;
  border-radius: 20px;
  padding: 10px;
  font-size: .85em;
}

.add-group-padding {
  padding: 10px;
}

.feedback {
  border: 2px solid #cb0101;
  padding: 4px;
  padding-left:8px;
  padding-right: 8px;
  margin-top: 10px;
  margin-right: 20px;
  margin-left: 20px;
  font-weight: 700;
  font-size: .85em;
  color: #cb0101;
}
</style>